export default __webpack_public_path__ + "static/media/na.521c5148.png";